export default __webpack_public_path__ + "static/media/me-removebg-preview.9eca358a.png";